export const average = arr => arr.reduce((p, c) => p + c, 0) / arr.length;
// REPLACE BY Math.clamp() when available!!!
export function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
}
export function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
